import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import layout from '@/views/layout'
import Cookies from 'js-cookie'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css' // Progress 进度条样式

import axioss from 'axios'
Vue.prototype.$http = axioss

const _import = require('./_import_' + process.env.NODE_ENV);
Vue.use(Router)

let router = new Router({
    routes: [{
            path: '/forgetPassword',
            name: 'forgetPassword',
            component: _import('/forgetPassword'),
            meta: {
                noAuth: true
            }
        },
        {
            path: '/member',
            name: 'member',
            component: _import('/member'),
            meta: {
                noAuth: true
            }
        },
        //{ path: '/', redirect: '/index/updateRecord' },

        // {
        //   path:'/demo',
        //   component:_import('/demo/index'),
        //   alias:'/',
        //   meta: {
        //     noAuth: true
        //   }
        // },
        {
            path: '/login',
            name: 'login',
            component: _import('/login'),
            meta: {
                noAuth: true
            }
        },

        // {
        // 	path: '/loginTest',
        // 	name: 'loginTest',
        // 	component: _import('/loginTest'),
        // 	meta: {
        // 		noAuth: true
        // 	}
        // },
        {
            path: '/qywxAuth/:path?',
            name: 'qywxAuth',
            component: _import('/qywxAuth'),
            props: true,
            meta: {
                title: '微信企业认证',
                noAuth: true
            }
        }

    ]
})

router.beforeEach((to, from, next) => {
    NProgress.start()
    store.dispatch('initSysConfig').then(() => {
        /* 判断要访问的路由是否需要权限访问 */
        if (to.meta && to.meta.noAuth) {
            //console.log(to.meta + ' --这是meta')
            next()
        } else {
            /* 判断是否有sessionId */
            //if( store.getters.hasSession ) {
            //暂时处理hasSession有时返回false的bug
            //console.log('判断token----')
            if (sessionStorage.getItem("token") ? true : false) {
                //console.log('--have token --' + sessionStorage.getItem("token"))
                /* 判断是否已读取用户信息 */
                if (store.getters.hasUserInfo) {
                    console.log('--have hasUserInfo --' + store.getters.hasUserInfo)
                    next()
                } else {
                    console.log('--no have hasUserInfo ')
                        /* 获取用户信息 */
                    store.dispatch('getUserInfo').then(res => {
                        //newRouters.push( { path: '*', redirect: '/404', hidden: true } )
                        //router.options.routes.push(...newRouters)
                        //
                        //console.log('--detail  ' + res.data)
                        let menuList = res.data.menuList
                            //console.log(res)

                        let menuRouters = []
                            /*先取出模块，没有父id的就是模块菜单*/
                        menuList.forEach((m, i) => {
                            //console.log(i)
                            if (m.parent_id == null) {
                                m.fullPath = '/' + m.path
                                let module = {
                                    path: '/' + m.path,
                                    component: layout,
                                    meta: { id: m.id, title: m.title, fullPath: '/' + m.path },
                                    children: [{
                                        path: '',
                                        component: _import('/' + m.path + '/index'),
                                        meta: {
                                            menuHide: true,
                                            title: m.title
                                        }
                                    }]
                                }
                                menuRouters.push(module)
                            }
                        })

                        function convertTree(routers) {
                            routers.forEach(r => {
                                menuList.forEach((m, i) => {
                                    if (m.parent_id && m.parent_id == r.meta.id) {
                                        if (!r.children) r.children = []
                                        m.fullPath = r.meta.fullPath + '/' + m.path
                                        let menu = {
                                            path: m.path,
                                            //component: () => import('@/views'+r.meta.fullPath+'/'+m.path),
                                            component: _import(r.meta.fullPath + '/' + m.path),
                                            meta: { id: m.id, title: m.title, fullPath: r.meta.fullPath + '/' + m.path }
                                        }
                                        r.children.push(menu)
                                            //console.log(i)
                                            //menuList.splice(i,1)
                                            // i--
                                    }
                                })
                                if (r.children) convertTree(r.children)
                            })
                        }
                        convertTree(menuRouters)

                        menuRouters.unshift({
                            path: '/index',
                            component: layout,
                            meta: { title: '首页', fullPath: '/index' },
                            children: [
                                //默认路径为空时自动跳转到对应文件下的index.vue页面
                                {
                                    path: '',
                                    component: _import('/index/index'),
                                    meta: {
                                        menuHide: true
                                    },
                                },
                                {
                                    path: '/sys/frbasictask/index',
                                    component: _import('/sys/frbasictask/index'),
                                    props: true,
                                    meta: {
                                        title: '任务提醒',
                                        fullPath: '/sys/frbasictask/index'
                                    }
                                },
                                //{
                                //         path: 'updateRecord',
                                //         component: _import('/index/updateRecord'),
                                //         meta: { title: '系统更新记录', fullPath: '/index/updateRecord' },
                                //     },
                                {
                                    path: 'modifyPwd',
                                    component: _import('/index/modifyPwd'),
                                    meta: { title: '修改密码', fullPath: '/index/modifyPwd' },
                                },
                                // {
                                // 	path: 'first',
                                // 	component: _import('/index/first'),
                                // 	meta: { title: '待开发', fullPath: '/index/first' },
                                // },
                                // {
                                // 	path: '/sys/frbasicmember/add',
                                // 	component: _import('/sys/frbasicmember/add'),
                                // 	props: true,
                                // 	meta: {
                                // 		title: '会员信息录入',
                                // 		fullPath: '/sys/frbasicmember/add'
                                // 	}
                                // },
                                // {
                                // 	path: '/sys/frbasicmember/list',
                                // 	component: _import('/sys/frbasicmember/list'),
                                // 	props: true,
                                // 	meta: {
                                // 		title: '会员信息列表',
                                // 		fullPath: '/sys/frbasicmember/list'
                                // 	}
                                // }
                            ]
                        })
                        store.dispatch('setRouters', menuRouters)
                        router.addRoutes(menuRouters)
                        router.addRoutes([{ path: '*', redirect: '/index' }])

                        next({...to, replace: true })
                            //router.replace("/")
                    })
                }
            } else {
                console.log('no--token----1008')
                router.push('login')
                    //next('/login')
            }
        }
    })


})

router.afterEach((to, from) => {
    NProgress.done() // 结束Progress
    if (to.meta && to.meta.title) {
        document.title = to.meta.title + ' | ' + store.state.sys.title
    } else {
        document.title = store.state.sys.title
    }
})

export default router